import { connect } from 'react-redux';
import MessageList from './MessageList';

import {
  fetchInboxMessages,
  fetchOutboxMessages,
  setMessageToRead,
} from '../../actions/messageAction';

const mapStateToProps = (state) => ({
  inbox: state.inbox,
  outbox: state.outbox,
  currentUser: state.currentUser,
});
const mapDispachToProps = (dispatch) => ({
  onMessageDisplay: (currentUserId) => dispatch(fetchInboxMessages(currentUserId)),
  onOutboxDisplay: (currentUserId) => dispatch(fetchOutboxMessages(currentUserId)),
  onMessagePress: (messageId) => dispatch(setMessageToRead(messageId)),
});

export default connect(mapStateToProps, mapDispachToProps)(MessageList);
